export default "__VITE_ASSET__lbMdJckg__"